module.exports = __webpack_public_path__ + "assets/img/_Novo RDR_Clubhouse w Linear Park_RGB_lr.ecec3733.jpg";